
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/legal-notice",
      function () {
        return require("private-next-pages/legal/legal-notice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/legal-notice"])
      });
    }
  